import { APIClient } from "./api_helper";

import * as url from "./url_helper";

const api = new APIClient();

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

// //is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// BN Rathi Client Dashboard
// Login API
export const postLogin = data => api.create(url.POST_LOGIN,data);
export const postResendPhoneOTP = token => api.getAuth(url.POST_RESEND_PHONE_OTP,token);
export const postVerifyPhoneOTP = (data,token) => api.createAuth(url.POST_VERIFY_OTP,data,token);

export const postForgotPassword = data => api.create(url.POST_FORGOT_PASSWORD,data);
export const postUpdatePassword = (data,token)=>api.createAuth(url.POST_UPDATE_PASSWORD,data,token)

// Logout Api
export const postLogOut = token => api.postLogOutAuth(url.GET_LOGOUT,token);

// profile detail 
export const getProfileDetail = token => api.getAuth(url.GET_PROFILE_DETAIL,token);
export const postUpdateProfilePassword = (params, token) => api.postAuthParam(url.POST_UPDATE_PASSWORD_PROFILE, params, token);

// home
export const getTotalInvestmentWithdrawal = token => api.getAuth(url.GET_TOTAL_INVESTMENT_WITHDRAWAL,token);
export const getTotalReturns = token => api.getAuth(url.GET_TOTAL_RETURNS,token);
export const getFinanceLedgerData = (params, token) => api.getAuthParam(url.GET_FINANCIAL_LEDGER, params, token);
export const getInvestmentSummery = (params, token) => api.getAuthParam(url.GET_INVESTMENT_SUMMERY, params, token);
export const getHomePortfolio = (params, token) => api.getAuthParam(url.GET_HOME_PORTFOLIO, params, token);
export const getHomeTradeConfirmMonths = token => api.getAuth(url.GET_HOME_TRADE_CONFIRMATION_MONTHS,  token);
export const getHomeTradeConfirmData = (params, token) => api.getAuthParam(url.GET_HOME_TRADE_CONFIRMATION_DATA, params, token);

//contract note 
export const getContractNoteList = (params, token) => api.getAuthParam(url.GET_CONTRACT_NOTE_LIST, params, token);
export const getContractNoteSingle = (params, token) => api.getAuthParam(url.GET_CONTRACT_NOTE_SINGLE, params, token, true);
export const getContractNoteZip = (params, token) => api.getAuthParam(url.GET_CONTRACT_NOTE_ZIP, params, token, true);
export const getContractNoteProcess = (params, token) => api.getAuthParam(url.GET_CONTRACT_NOTE_PROCESS, params, token);

//annexure
export const getAnnexureDetails = token => api.getAuth(url.GET_ANNEXURE_DETAILS,token);

// support 
export const getSupportCategories = token => api.getAuth(url.GET_SUPPORT_CATEGORIES,token);
export const postSupportQuery = (body, token) => api.postAuth(url.POST_SUPPORT_QUERY, body, token);

// Share report on email  
export const postEmailReport = (body, token) => api.postAuth(url.POST_EMAIL_REPORT, body, token);

// Add annual income 
export const postAddAnnualIncome =  (body, token) => api.storeAuth(url.POST_ADD_ANNUAL_INCOME,body, token);

// Get state and city 
export const getStateCity =  (params, token) => api.getAuthParam(url.GET_STATE_CITY_LIST,params, token);

// Add Nominee 
export const postAddNominee =  (body, token) => api.storeAuth(url.POST_ADD_NOMINEE,body, token);

// Register Method
export const postFakeRegister = data => api.create(url.POST_FAKE_REGISTER, data);

// Login Method
export const postFakeLogin = data => api.create(url.POST_FAKE_LOGIN, data);

// postForgetPwd
export const postFakeForgetPwd = data => api.create(url.POST_FAKE_PASSWORD_FORGET, data);

// Edit profile
export const postJwtProfile = data => api.create(url.POST_EDIT_JWT_PROFILE, data);

export const postFakeProfile = (data) => api.update(url.POST_EDIT_PROFILE + '/' + data.idx, data);

// Add profile image 
export const postAddProfileImage = (body, token) => api.postAuthAdd(url.POST_ADD_PROFILE_IMAGE, body, token);

// Re_kyc 
export const postDigioRequest =  (params, token) => api.postAuthParam(url.POST_DIGIO_REQUEST,params, token);
export const postEmailSendOtp =  (params, token) => api.postAuthParam(url.POST_EMAIL_SEND_OTP,params, token);
export const postEmailVerifyOtp =  (params, token) => api.postAuthParam(url.POST_EMAIL_OTP_VERIFY,params, token);
export const postPhoneSendOtp =  (params, token) => api.postAuthParam(url.POST_PHONE_SEND_OTP,params, token);
export const getRe_KYC_RequestResponse =  (params, token) => api.getAuthParam(url.GET_RE_KYC_REQUEST_RESPONSE,params, token);
export const getRe_KYC_BankVerify =  (params, token) => api.getAuthParam(url.GET_RE_KYC_BANK_VERIFY,params, token);
export const postNomineeNotOpted = ( token) => api.postAuthWithoutParam(url.POST_NOMINEE_NOT_OPTED,  token, true);
export const postSendEsignRequest =  (params, token) => api.postAuthParam(url.POST_SEND_ESIGN_REQUEST,params, token);
export const getKRA_Data =  (params, token) => api.getAuthParam(url.GET_KRA_DATA,params, token);
export const getEsignDocumentDownload =  (params, token) => api.getAuthParam(url.GET_ESIGN_DOCUMENT_DOWNLOAD,params, token, true);
export const postUpdatePersonalDetails = (body, token) => api.postAuthAdd(url.POST_UPDATE_PERSONAL_DETAILS, body, token);
export const postUpdateOtherDetails = (body, token) => api.postAuthAdd(url.POST_UPDATE_OTHER_DETAILS, body, token);
export const getBranchDetails =  (params, token) => api.getAuthParam(url.GET_BRANCH_DETAILS,params, token);
export const postAddBank =  (params, token) => api.postAuthParam(url.POST_ADD_BANK_DETAILS,params, token);
export const postUpdateBank =  (body, token) => api.postAuthAdd(url.POST_UPDATE_BANK_DETAILS,body, token);
export const postUploadDocumentsRekyc =  (body, token) => api.postAuthAdd(url.POST_UPLOAD_DOCUMENTS_REKYC,body, token);
export const postAccountClosure =  (body, token) => api.postAuthAdd(url.POST_CLOSURE_ACCOUNT,body, token);
export const postSendRekycApplication = ( token) => api.postAuthWithoutParam(url.POST_SEND_REKYC_APPLICATION,  token);
export const getValidatePersonalDetails = ( token) => api.getAuthWithoutParam(url.GET_VALIDATE_PERSONAL_DETAILS,  token);
export const postPanUtility =  (params, token) => api.postAuthParam(url.POST_PAN_UTILITY,params, token);


// Register Method
export const postJwtRegister = (url, data) => {
  return api.create(url, data)
    .catch(err => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message = "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method
export const postJwtLogin = data => api.create(url.POST_FAKE_JWT_LOGIN, data);

// postForgetPwd
export const postJwtForgetPwd = data => api.create(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

// postSocialLogin
export const postSocialLogin = data => api.create(url.SOCIAL_LOGIN, data);

